var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "panel bg-transparent columns large-6 medium-12 large-centered",
      },
      [
        _c("p", {
          domProps: {
            innerHTML: _vm._s(_vm.t("forms.are_you_preregistered.IC_0126")),
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-center" }, [
          _c("label", [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.t("forms.are_you_preregistered.IC_0127")),
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.regCode,
                  expression: "regCode",
                },
              ],
              staticClass: "no-margin",
              attrs: { type: "text", maxlength: "6" },
              domProps: { value: _vm.regCode },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.checkRegistrationCode($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.regCode = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.regCodeError
              ? _c("small", { staticClass: "error" }, [
                  _vm._v(
                    "Invalid entry, Activation Code should be 6 characters"
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "columns large-3" }, [
              _c("button", {
                staticClass: "tiny radius marginTop expand",
                domProps: {
                  textContent: _vm._s(
                    _vm.t("forms.are_you_preregistered.IC_0128")
                  ),
                },
                on: { click: _vm.checkRegistrationCode },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns large-3" }, [
              _c("button", {
                staticClass: "tiny radius marginTop expand",
                domProps: { textContent: _vm._s(_vm.t("register.user_guide")) },
                on: { click: _vm.openGuide },
              }),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }